import { environment } from './../../environments/environment';

export const getFilePath = (path: string | undefined | null) => {
  return path ? `${environment.BASE_URL}/media/${path}` : '/assets/images/no-image.png';
};

export * from './date-utils';
